/*
 * PostHog for pages where first paint matters more than the first seconds of
 * analytics (the marketing site), mirroring observability's
 * initializeSentryDeferred.
 *
 * `initializeAnalytics` validates env through `keys()` (t3-env + zod) and
 * imports posthog-js statically, so both landed in the first-load bundle of
 * every marketing page. Here the NEXT_PUBLIC_* values are read directly (Next
 * inlines them at build time) and posthog-js loads once the page is idle.
 */

const IDLE_TIMEOUT_MS = 4000;
const FALLBACK_DELAY_MS = 2000;

/**
 *
 */
export const initializeAnalyticsDeferred = (): void => {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

  if (!(posthogKey?.startsWith("phc_") && posthogHost)) {
    return;
  }

  const load = async () => {
    const { default: posthog } = await import("posthog-js");
    posthog.init(posthogKey, {
      api_host: posthogHost,
      defaults: "2025-05-24",
      capture_exceptions: true,
    });
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(load, { timeout: IDLE_TIMEOUT_MS });
  } else {
    setTimeout(load, FALLBACK_DELAY_MS);
  }
};
